import React, { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@Sage/hoi-poi-ui';

import { useWeb5Context } from 'lib/Web5Context';

import ExportImplementationsModal from './ExportImplementationsModal';

const ExportImplementations = ({ filters }) => {
    const { t } = useWeb5Context();
    const exportModalRef = useRef();

    const onClickExportButton = useCallback(() => {
        exportModalRef.current?.open(filters);
    }, [filters]);

    const setExportModalRef = useCallback((ref) => {
        exportModalRef.current = ref;
    }, []);

    return (
        <>
            <Button
                type="secondary"
                onClick={onClickExportButton}
                icon="fileDownload"
                iconPosition="right"
            >
                {t('cfm_action_export')}
            </Button>
            <ExportImplementationsModal onRef={setExportModalRef} />
        </>
    );
};

ExportImplementations.displayName = 'ExportImplementations';

ExportImplementations.propTypes = {
    filters: PropTypes.object,
};

export default ExportImplementations;
